import { getTrendingTopicsCsvFile } from '@/services/dashboard-service/dashboard.service';
import { TrendingTopicsExportParams } from '@/services/dashboard-service/dashboard.service.types';
import { downloadTrendingTopicsCSVFile } from '@/utils/helpers';
import { useState } from 'react';

export const useTrendingTopicsExport = (params: TrendingTopicsExportParams) => {
  const [isPending, setIsPending] = useState(false);

  const downloadTrendingTopics = async () => {
    setIsPending(true);
    const data = await getTrendingTopicsCsvFile(params);
    if (typeof data === 'string') {
      downloadTrendingTopicsCSVFile(data);
      setIsPending(false);
      return data;
    }
    setIsPending(false);
  };

  return { downloadTrendingTopics, isPending };
};
